import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class MasonryController {
    private itemsHeight$ = new BehaviorSubject<Record<string, number>>({});
    private items: { key: string | number; item: HTMLElement }[] = [];

    constructor(private logger?: LoggerInterface) {}

    register(key: string | number, item: HTMLElement) {
        if (this.items.find((item) => item.key === key)) {
            const errMsg = "Key is already exists in registered items";
            this.logger?.error(errMsg, { key });

            throw new Error(errMsg);
        }

        this.items.push({ key, item });
        this.logger?.debug(`item with key: ${key} registered`);

        return () => this.unregister(key);
    }

    private unregister(key: string | number) {
        const itemIdx = this.items.findIndex((item) => item.key === key);

        if (itemIdx > -1) {
            this.items.splice(itemIdx, 1);
            this.logger?.debug(`item with key: ${key} unregistered`);
            return;
        }

        this.logger?.debug(`item with key: ${key} not found for unregister`);
    }

    select(key: string | number) {
        return this.itemsHeight$.pipe(
            map((itemsHeight) => {
                return itemsHeight[key] || 0;
            })
        );
    }

    update() {
        const rowHeight = 20;
        const rowGap = 10;
        const gridItemStyles = this.itemsHeight$.getValue();

        this.logger?.debug("layout update triggered");

        Promise.resolve()
            .then(() => {
                this.items.forEach(({ item }) => {
                    const contentEl = item.firstElementChild as HTMLElement;
                    contentEl.style.height = "auto";
                });

                this.items.forEach(({ key, item }) => {
                    const contentEl = item.firstElementChild as HTMLElement;

                    const rowSpan = Math.ceil(
                        (contentEl.clientHeight + rowGap) / (rowHeight + rowGap)
                    );

                    gridItemStyles[key] = rowSpan;
                });

                this.items.forEach(({ item }) => {
                    const contentEl = item.firstElementChild as HTMLElement;
                    contentEl.style.height = "100%";
                });

                this.itemsHeight$.next(gridItemStyles);
            })
            .catch((e) => {
                const error = e as Error;
                this.logger?.error(error.message);
            });
    }
}

export default MasonryController;
